<section>
    <app-vca-filter [pageId]="pageId" [modes]="modes" [userInfos]="userInfos" [platformInfos]="platformInfos" (filterDataOutputEvent)="filterUploadContent($event)"
    style="padding: 8px;"></app-vca-filter>
    
    <app-upload-content #appUploadContent [platformInfos]="platformInfos" [userInfos]="userInfos" [filterData]="filterData" (inProgress)="setProgress($event)" [acceptedExtention]="acceptedExtention" (uploadEvent)="uploadEvent($event)"></app-upload-content>
  </section>